import { Config } from 'zv-components'

Config.iconPath = globalConfigs.paths.icons
